import { createElement } from 'react';
import { node, string, bool, oneOf } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import ColumnsContext from './ColumnsContext.js';
import _Columns from './styled.js';

var Columns = function Columns(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isGapless = _ref.isGapless,
      isOneLine = _ref.isOneLine,
      minBreakpoint = _ref.minBreakpoint,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "isGapless", "isOneLine", "minBreakpoint"]);

  return createElement(ColumnsContext.Provider, {
    value: {
      isGapless: isGapless,
      minBreakpoint: minBreakpoint
    }
  }, createElement(_Columns, _extends({
    className: className,
    isGapless: isGapless,
    isOneLine: isOneLine,
    minBreakpoint: minBreakpoint
  }, props), children));
};
var columnsPropTypes = {
  children: node.isRequired,
  className: string,
  isGapless: bool,
  isOneLine: bool,
  minBreakpoint: oneOf(['tablet', 'mobile'])
};
Columns.propTypes = columnsPropTypes;
var columnsDefaultProps = {
  className: undefined,
  isGapless: false,
  isOneLine: false,
  minBreakpoint: undefined
};
Columns.defaultProps = columnsDefaultProps;
var C = Columns;

export default C;
export { C as Columns, columnsDefaultProps, columnsPropTypes };
